import {useEffect} from 'react';

export const isNumericInput = (element: EventTarget | null): element is HTMLInputElement =>
    element instanceof HTMLInputElement && (element.type === 'number' || element.inputMode === 'decimal');

export const useSelectNumericInputOnFocus = () => {
    useEffect(() => {
        const selectValue = (event: FocusEvent) => {
            if (isNumericInput(event.target)) event.target.select();
        };

        document.addEventListener('focusin', selectValue);
        return () => document.removeEventListener('focusin', selectValue);
    }, []);
};
